import { useEffect, useRef } from 'react';
import SiteHeader from './components/SiteHeader';
import SiteFooter from './components/SiteFooter';
import LabPage from './pages/LabPage';
import AboutPage from './pages/AboutPage';
import ElementsIndexPage from './pages/ElementsIndexPage';
import ElementPage from './pages/ElementPage';
import ReactionsIndexPage from './pages/ReactionsIndexPage';
import ReactionPage from './pages/ReactionPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import ContactPage from './pages/ContactPage';
import ParentsTeachersPage from './pages/ParentsTeachersPage';
import WorksheetPage from './pages/WorksheetPage';
import WorksheetAnswersPage from './pages/WorksheetAnswersPage';
import NotFoundPage from './pages/NotFoundPage';
import { RouterProvider, useRouter } from './context/RouterContext';
import { APP_CLASSES } from './constants/classNames';
import { getPageMeta } from './data/pageMeta';
import { applyHeadTags } from './utils/headUtils';
import { matchRoute } from './utils/routeUtils';

const PAGES = {
  lab: LabPage,
  about: AboutPage,
  elements: ElementsIndexPage,
  element: ElementPage,
  reactions: ReactionsIndexPage,
  reaction: ReactionPage,
  privacy: PrivacyPage,
  terms: TermsPage,
  contact: ContactPage,
  parents: ParentsTeachersPage,
  worksheet: WorksheetPage,
  'worksheet-answers': WorksheetAnswersPage,
  'not-found': NotFoundPage,
};

function CurrentPage() {
  const { path } = useRouter();
  const route = matchRoute(path);
  const isFirstRender = useRef(true);

  // The first page already has its tags in the pre-rendered HTML; later pages update them.
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    applyHeadTags(getPageMeta(path));
  }, [path]);

  const Page = PAGES[route.page];
  return (
    <div className={APP_CLASSES.root}>
      <SiteHeader currentPage={route.page} />
      <main className={APP_CLASSES.main}>
        <Page key={path} slug={route.slug} />
      </main>
      <SiteFooter />
    </div>
  );
}

/**
 * initialLocation is only passed when pre-rendering pages at build time.
 */
export default function App({ initialLocation }) {
  return (
    <RouterProvider initialLocation={initialLocation}>
      <CurrentPage />
    </RouterProvider>
  );
}
